<div class="row g-3 mb-3 d-print-none" *ngIf="listData?.length > 0">
	<div class="col-9">
	</div>
	<div class="col-3 text-end">
		<button (click)="onPrint()" class="btn btn-primary" id="btn-print">
			<i class="bi bi-printer"></i> Imprimir
		</button>
	</div>
</div>
<main class="relatorio2" *ngIf="listData?.length > 0">
  <div class="row-fluid">
	  <div class="col-12">
      <ul class="breadcrumb ac-breadcrumb clearfix">
          <li class="active">Pré-Projetos</li>
          <li class="pull-right">			
        </li>
      </ul>
      <div class="responsive-table">
        <table id="tb-accord-update" class="table table-bordered table-hover table-agency">
          <thead>
            <tr class="tr-ind-header">
              <th width="9%">Código</th>
              <th width=""><div class="text-center">Projeto</div></th>
              <th width="12%"><div class="text-center">Órgão Responsável</div></th>
              <th width="9%"><div class="text-center">Projeto Selecionado</div></th>
              <th width="16%"><div class="text-center">Custo total estimado</div></th>
              <th width="16%"><div class="text-center">Valor da Contrapartida</div></th>
              <th width="16%"><div class="text-center">Valor Concedente / Financiamento</div></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let linha of listData; let i = index">
              <td class="text-center">{{ linha.id }}</td>
              <td>{{ linha.title.toUpperCase() }}</td>
              <td class="text-center">{{ linha.agency_name }}</td>
              <td class="text-center">{{ linha.project_selected ? 'Sim' : 'Não' }}</td>
              <td class="text-center">{{ linha.cost_total | number:'1.2-2' }}</td>
              <td class="text-center">{{ linha.cost_without_loan | number:'1.2-2' }}</td>
              <td class="text-center">{{ linha.cost_loan | number:'1.2-2' }}</td>
            </tr>
            <tr *ngIf="sumTotals(listData) as total">
              <td colspan="2" class="text-end">Totais de projetos:</td>
              <td class="text-center">{{ total.agency_count }}</td>
              <td class="text-center"></td>
              <td class="text-center">{{ total.cost_total | number:'1.2-2' }}</td>
              <td class="text-center">{{ total.cost_without_loan | number:'1.2-2' }}</td>
              <td class="text-center">{{ total.cost_loan | number:'1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</main>
<app-loading [loader]="isLoading"></app-loading>